export default __webpack_public_path__ + "static/media/w_ex_obesity.6e671d66.svg";